<template>
  <MobileNavHeader v-bind="normalizedData" />
</template>

<script setup>
import { computed } from 'vue';
import { useHamburgerMenu } from '~/composables/useHamburgerMenu';
import { useMobileNav } from '~/composables/useMobileNav';
import MobileNavHeader from './MobileNavHeader.common';

const props = defineProps({
  data: {
    /** @type import('vue').PropType<MobileFlyoutElement> */
    type: Object,
    required: true,
  },
});

const { menu } = useHamburgerMenu();
const { stack, lastStackItem } = useMobileNav();

/*
 * @param {string} currentTitle
 * @returns {string}
 * Returns the actual active category title, considering the stack of categories.
 * If the stack only contains the root category, it returns the current title.
 * Otherwise, it returns the title based on the link text of the previous category children.
 */
function getActualActiveCategoryTitle(currentTitle) {
  const stackLength = stack.value.length;

  if (stackLength < 2) {
    return currentTitle;
  }

  const prevCategory = menu.value[stack.value[stackLength - 2].id];
  const currentCategoryId = lastStackItem().id;

  return prevCategory?.children.find(({ id }) => id === currentCategoryId)?.text || currentTitle;
}

const normalizedData = computed(() => ({
  ...props.data,
  title: getActualActiveCategoryTitle(props.data.title),
}));
</script>
